import React, { useState, useRef, useEffect } from "react";

import "./CountrySelect.scss";

import { COUNTRIES } from "../../constants/Countries";

const CountrySelect = (props) => {
  const { value, onChange, placeholder = "Select a country" } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const selectedCountry = COUNTRIES.find((c) => c.label === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredCountries = COUNTRIES.filter((country) =>
    country.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCountrySelect = (country) => {
    onChange(country.label, country.code);
    setIsOpen(false);
    setSearchTerm("");
  };

  return (
    <div className="country-select-wrapper" ref={dropdownRef}>
      <div className="country-select-input" onClick={() => setIsOpen(!isOpen)}>
        {selectedCountry ? (
          <div className="country-select-selected">
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${selectedCountry.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${selectedCountry.code.toLowerCase()}.png`}
              alt={selectedCountry.label}
            />
            <span>{selectedCountry.label}</span>
          </div>
        ) : (
          <span className="country-select-placeholder">{placeholder}</span>
        )}
        <span className="country-select-arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div className="country-select-dropdown">
          <div className="country-select-search">
            <input
              type="text"
              placeholder="Search country..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="country-select-search-input"
              autoFocus
            />
          </div>
          <div className="country-select-options">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <div
                  key={country.code}
                  className={`country-select-option ${
                    selectedCountry?.code === country.code ? "selected" : ""
                  }`}
                  onClick={() => handleCountrySelect(country)}
                >
                  <img
                    loading="lazy"
                    width="20"
                    srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
                    src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                    alt={country.label}
                  />
                  <span>{country.label}</span>
                </div>
              ))
            ) : (
              <div className="country-select-no-results">
                No countries found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelect;
